import type { HourBuckets, PayRule, TimeEntryFlags } from "./types.js";
import { getActiveRule, ruleThreshold } from "./helpers.js";

export function allocateHours(
  hoursWorked: number,
  cumulativeWeeklyHoursBefore: number,
  rules: PayRule[],
  flags: TimeEntryFlags,
): HourBuckets {
  const holidayRule = getActiveRule(rules, "HOLIDAY");
  if (flags.isHoliday && holidayRule) {
    return { regular: 0, overtime: 0, doubleTime: 0, holiday: hoursWorked };
  }

  const dailyOtRule = getActiveRule(rules, "DAILY_OT");
  const dailyDtRule = getActiveRule(rules, "DAILY_DT");
  const weeklyOtRule = getActiveRule(rules, "WEEKLY_OT");
  const weeklyDtRule = getActiveRule(rules, "WEEKLY_DT");

  const dailyOtThreshold = dailyOtRule ? ruleThreshold(dailyOtRule, 8) : Infinity;
  const dailyDtThreshold = dailyDtRule ? ruleThreshold(dailyDtRule, 12) : Infinity;

  let regular = dailyOtRule ? Math.min(hoursWorked, dailyOtThreshold) : hoursWorked;
  let overtime = 0;
  let doubleTime = 0;

  if (dailyDtRule && dailyDtThreshold > dailyOtThreshold) {
    const hoursAboveRegular = Math.max(0, hoursWorked - dailyOtThreshold);
    overtime = Math.min(hoursAboveRegular, dailyDtThreshold - dailyOtThreshold);
    doubleTime = Math.max(0, hoursWorked - dailyDtThreshold);
  } else if (dailyOtRule) {
    overtime = Math.max(0, hoursWorked - dailyOtThreshold);
  }

  if (weeklyOtRule) {
    const weeklyOtThreshold = ruleThreshold(weeklyOtRule, 40);
    const weeklyOtHours = Math.max(
      0,
      Math.min(regular, cumulativeWeeklyHoursBefore + regular - weeklyOtThreshold),
    );
    regular -= weeklyOtHours;
    overtime += weeklyOtHours;
  }

  if (weeklyDtRule) {
    const weeklyDtThreshold = ruleThreshold(weeklyDtRule, 48);
    const weeklyDtHours = Math.max(
      0,
      Math.min(
        regular,
        cumulativeWeeklyHoursBefore + regular + overtime + doubleTime - weeklyDtThreshold,
      ),
    );
    regular -= weeklyDtHours;
    doubleTime += weeklyDtHours;
  }

  return { regular, overtime, doubleTime, holiday: 0 };
}
